export enum PriceChangeType {
  Undefined = 0,
  Change = 1,
  Adjustment = 2,
}
